import {
  CreateExportsExportDocument,
  CreateExportsExportMutationVariables,
  ExportsExporterDocument,
  ExportsExporterQueryVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { requiresOptions } from 'modules/universal_exports/lib/exporter'

export const useCreateExport = () => {
  const [createExport, { loading }] = useMutation(CreateExportsExportDocument, {
    extractorFn: (data) => data.universalExportsMutations.createUniversalexportsExport,
  })

  return {
    create: (variables: CreateExportsExportMutationVariables) => createExport({ variables }),
    loading,
  }
}

export const useExporter = (variables: ExportsExporterQueryVariables) => {
  const { data, loading, refetch } = useQuery(ExportsExporterDocument, {
    variables,
  })

  const node = data?.universalExports.exportersConnection.nodes[0]
  const filters = node?.filters?.filter((f) => !requiresOptions(f.kind) || f.options?.length) ?? []

  return {
    loading,
    filters,
    fields: node?.fields ?? [],
    extraOptions: node?.extraOptions ?? [],
    label: node?.label,
    groupableColumns: node?.groupableColumns ?? [],
    refetch,
  }
}
